import { FC, memo } from 'react'
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  FormHelperText,
  FormControlProps,
  Flex,
  Image,
  useColorModeValue,
} from '@chakra-ui/react'

type Error = {
  message?: string
}

type Props = FormControlProps & {
  labelSrc?: string
  helperText?: string
  htmlFor?: string
  label?: string
  error?: Error
}

const FormItem: FC<Props> = ({ labelSrc, error, helperText, htmlFor, label, children, ...rest }) => {
  const hasError = error !== undefined

  const helperTextColor = useColorModeValue('gray.400', 'gray.400')

  return (
    <FormControl isInvalid={hasError} mb={2} {...rest}>
      {labelSrc ? (
        <Flex align="center" gap={2} pb={helperText ? 0 : 2} mb={1}>
          <Image height={4} src={labelSrc} alt="Imagem" />
          <FormLabel htmlFor={htmlFor}>{label}</FormLabel>
        </Flex>
      ) : (
        <FormLabel htmlFor={htmlFor} pb={helperText ? 0 : 2} mb={1}>
          {label}
        </FormLabel>
      )}

      {helperText && (
        <FormHelperText color={helperTextColor} mt={0} mb={2} p={0}>
          {helperText}
        </FormHelperText>
      )}
      {children}
      {hasError && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  )
}

export default memo(FormItem)
